import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useEffect, useState } from 'react';
import {
  createNewSurveyAnswer,
  deleteSurveyAnswer,
} from 'redux/slices/legacySurveySlice';
import { useAppDispatch } from 'redux/store-hooks';
import type { SurveyProps } from './types';

const SurveyRadio = ({
  question,
  register,
  unregister,
  error,
  response,
  setValue,
  getValues,
}: SurveyProps) => {
  const [selectValue, setSelectValue] = useState('');
  const dispatch = useAppDispatch();

  const registerProps = register(question.id, {
    required: question.isRequired,
  });

  useEffect(() => {
    const initialValue = getValues(question.id);
    if (initialValue) {
      setSelectValue(initialValue);
    }

    return () => {
      unregister(question.id);
    };
  }, []);

  const handleChange = event => {
    let value = event.target.value;
    if (value === selectValue) {
      value = '';
    }
    setSelectValue(value);
    setValue(question.id, value);
    if (value) {
      dispatch(
        createNewSurveyAnswer({
          body: {
            questionId: question.id,
            responseId: response.id,
            optionId: value,
          },
        })
      );
    } else {
      dispatch(
        deleteSurveyAnswer({
          params: {
            questionId: question.id,
            responseId: response.id,
          },
        })
      );
    }
  };

  const helperText = () => {
    if (!error) return '';

    if (error?.type === 'required') {
      return 'A value is required';
    }

    return 'An error has occurred';
  };

  return (
    <FormControl error={!!error}>
      <RadioGroup
        aria-labelledby={`ql-${question.id}`}
        defaultValue="female"
        name="radio-buttons-group"
      >
        {question.options.map(option => {
          return (
            <FormControlLabel
              key={option.id}
              label={option.text}
              value={option.id}
              checked={selectValue.includes(option.id)}
              control={<Radio {...registerProps} onClick={handleChange} />}
            />
          );
        })}
      </RadioGroup>
      <FormHelperText>{helperText()}</FormHelperText>
    </FormControl>
  );
};

export default SurveyRadio;
